// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"E5-z","dimensionLabel":"F5-z","styleChooserControlWrapper":"G5-z","styleChooserControl":"H5-z","disabled":"I5-z","giftCard":"J5-z","styleChooserText":"K5-z"};